export const GET_TEST_RESULT_DETAILS = 'TEST_RESULTS.GET_TEST_RESULT_DETAILS';
export const GET_TEST_RESULT_DETAILS_SUCCESS = 'TEST_RESULTS.GET_TEST_RESULT_DETAILS_SUCCESS';
export const GET_TEST_RESULT_DETAILS_FAIL = 'TEST_RESULTS.GET_TEST_RESULT_DETAILS_FAIL';

export const RESET_TEST_RESULT_DETAILS = 'TEST_RESULTS.RESET_TEST_RESULT_DETAILS';

export const GET_TEST_RESULTS_LIST = 'TEST_RESULTS.GET_TEST_RESULTS_LIST';
export const GET_TEST_RESULTS_LIST_FAIL = 'TEST_RESULTS.GET_TEST_RESULTS_LIST_FAIL';
export const GET_TEST_RESULTS_LIST_SUCCESS = 'TEST_RESULTS.GET_TEST_RESULTS_LIST_SUCCESS';
export const SET_TEST_RESULTS_LIST_LAST_UPDATED = 'TEST_RESULTS.SET_TEST_RESULTS_LIST_LAST_UPDATED';

export const GET_TEST_RESULTS_LIST_CACHE_SUCCESS =
  'TEST_RESULTS.GET_TEST_RESULTS_LIST_CACHE_SUCCESS';

export const GET_TEST_RESULT_LIST_BY_ENCOUNTER = 'TEST_RESULTS.GET_TEST_RESULT_LIST_BY_ENCOUNTER';
export const GET_TEST_RESULT_LIST_BY_ENCOUNTER_FAIL =
  'TEST_RESULTS.GET_TEST_RESULT_LIST_BY_ENCOUNTER_FAIL';
export const GET_TEST_RESULT_LIST_BY_ENCOUNTER_SUCCESS =
  'TEST_RESULTS.GET_TEST_RESULT_LIST_BY_ENCOUNTER_SUCCESS';

export const GET_LAB_WITH_DETAILS = 'TEST_RESULTS.GET_LAB_WITH_DETAILS';
export const GET_LAB_WITH_DETAILS_FAIL = 'TEST_RESULTS.GET_LAB_WITH_DETAILS_FAIL';
export const GET_LAB_WITH_DETAILS_SUCCESS = 'TEST_RESULTS.GET_LAB_WITH_DETAILS_SUCCESS';

export const UPDATE_SORT = 'TEST_RESULTS.UPDATE_SORT';
export const UPDATE_FILTER_OPTIONS = 'TEST_RESULTS.UPDATE_FILTER_OPTIONS';
export const UPDATE_DATE_RANGE = 'TEST_RESULTS.UPDATE_DATE_RANGE';
export const APPLY_TEST_RESULTS_FILTERS = 'TEST_RESULTS.APPLY_TEST_RESULTS_FILTERS';
export const RESET_TEST_RESULTS_FILTERS = 'TEST_RESULTS.RESET_TEST_RESTULS_FILTERS';
